import React from 'react';

import './fitment-size-group.scss';

interface FitmentSizeGroupProps {
  className?: string;
}

function FitmentSizeGroup(
  props: React.PropsWithChildren<FitmentSizeGroupProps>
) {
  const { children, className = '' } = props;

  return (
    <div className={`fitment-size-group ${className}`} styleName="container">
      {children}
    </div>
  );
}

export default FitmentSizeGroup;
